import { memo } from "react";

import { ProgressBar } from "@components/ProgressBar";
import { Text } from "@components/Text";
import { type TTailwindString, tw } from "classnames";

type Props = {
  hasReachedThreshold: boolean;
  progressPercentage: number;
  progressText: string;
};

const styles = {
  container: tw(
    "w-full",
    "pt-2",
    "pb-4",
    "flex",
    "flex-row",
    "items-center",
    "justify-between",
    "bg-background-primary"
  ),
  text: (hasReachedThreshold: boolean) =>
    tw("mr-4", "transition-all", "duration-200", {
      "text-misc-bright-blue": hasReachedThreshold,
    }),
  bar: tw(
    "max-w-[98px]" as TTailwindString,
    "md:max-w-[136px]" as TTailwindString
  ),
};

const CartFreeShippingProgressBarViewBase = ({
  hasReachedThreshold,
  progressPercentage,
  progressText,
}: Props) => {
  return (
    <div className={styles.container}>
      <Text className={styles.text(hasReachedThreshold)} size="sm">
        {progressText}
      </Text>
      <ProgressBar
        className={styles.bar}
        progressPercentage={progressPercentage}
        size="sm"
        type="cart"
      />
    </div>
  );
};

export const CartFreeShippingProgressBarView = memo(
  CartFreeShippingProgressBarViewBase
);
